import { render, staticRenderFns } from "./DeleteColumnMenu.vue?vue&type=template&id=edb6bd36&"
import script from "./DeleteColumnMenu.vue?vue&type=script&lang=js&"
export * from "./DeleteColumnMenu.vue?vue&type=script&lang=js&"
import style0 from "./DeleteColumnMenu.vue?vue&type=style&index=0&id=edb6bd36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports